import { Leaf, NewsLetterHeader } from '@arvesta-websites/icons';

import type { Config } from '../default-config';
import mergeConfig from '../merge-config';

const config: Config = mergeConfig({
  CtaMask: Leaf,
  NewsletterHeader: {
    SVG: NewsLetterHeader.AveveAgrarisch,
    className: 'newsletter-svg',
  },
  breadcrumb: {
    display: false,
  },
  button: {
    ctaBanner: {
      image: 'secondary',
      text: 'primary-with-background',
    },
    dealerOverview: {
      details: 'primary',
      navigation: 'primary',
    },
    infoBlock: 'secondary',
    infoBlockColumns: 'secondary',
    infoSection: 'primary-with-background',
    shortBanner: 'primary-with-background',
  },
  footer: {
    newsletter: {
      removeBottomPadding: false,
    },
    version: 'V2',
  },
  heroBanner: {
    customOverlay: true,
    mask: false,
  },
  mapSearchRadius: 20000, // in meters!!
});

export default config;
